// @flow

// Libs
import _head from 'lodash/head'

// Effect Managers
import { select, put, take } from 'redux-saga/effects'

// Actions
import { updateCurrentSeason } from '../actions'

// Selectors
import { sortedSeasons$ } from 'fc-seasons'
import { selectedSeasonId$ } from 'hfty-seasons'

// Constants
import { RECEIVE_AUTHENTICATED_USER } from 'fc-authenticated-user'

// Controllers
import environmentCtrl from 'fc-ctrl-environment'
import seasonCtrl from 'fc-ctrl-seasons'

export default function *setDefaultSeason (): Generator<*, *, *> {
  const status = {}
  const RECEIVE_SEASON = seasonCtrl.actionTypes.receive()
  const RECEIVE_ENVIRONMENT = environmentCtrl.actionTypes.receive()
  let done = false

  while (!done) {
    const { type } = yield take([
      RECEIVE_SEASON,
      RECEIVE_ENVIRONMENT,
      RECEIVE_AUTHENTICATED_USER,
    ])

    status[type] = true

    const isAllDependenciesReady = status[RECEIVE_SEASON] &&
      status[RECEIVE_ENVIRONMENT] &&
      status[RECEIVE_AUTHENTICATED_USER]

    if (isAllDependenciesReady) {
      const selectedSeason = yield select(selectedSeasonId$)

      if (!selectedSeason) {
        const seasons = yield select(sortedSeasons$)
        const defaultSeason = _head(seasons)

        yield put(updateCurrentSeason(defaultSeason.id))
      }
      done = true
    }
  }
}
